/* eslint-disable */

/****
 *
 *
 * This file is an example of how NOT to manage icons.
 * It is only still here because it is deeply entangled and needs time to be refactored
 * Please do not put any new icons in here, and ideally do not use any of these
 * For more information, see the readme.
 *
 *
 *
 *
 *
 */

import React from 'react'

interface Props {
	color?: string
	colorSecondary?: string
	outline?: string
	width?: number
	style?: React.CSSProperties
}

export const FionaLogo = (props: Props) => (
	<img width={93} height={28} src="/images/fiona-logo.svg" alt="Fiona Logo" {...props} />
)
export const JerryLogo = (props: any) => <img src="/images/logo_jerry.svg" alt="Jerry Logo" {...props} />

export const ExternalIconBold = (props: any) => (
	<img src="/images/ic_external-bold.svg" alt="External Icon" {...props} />
)

export const ExternalIconBoldBlack = (props: any) => (
	<img src="/images/external-bold-black.svg" alt="External Icon" {...props} />
)

export const ErrorIcon = (props: any) => <img src="/images/error-icon.svg" alt="Error Icon" {...props} />
export const LightBulbImage = (props: any) => <img src="/images/light-bulb.svg" alt="Light bulb" {...props} />
export const StarCirlce = (props: any) => <img src="/images/star_circle.svg" alt="Star Circle" {...props} />
export const FilterIcon = (props: any) => <img src="/images/filter_icon.svg" alt="Filter Icon" {...props} />

export const FacebookIcon = ({ color }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<g id="prefix__icons_ic_facebook" data-name="icons / ic_facebook" transform="translate(777 50)">
			<path
				id="prefix__flogo-HexRBG-Wht-58"
				d="M18.895 0H1.105A1.105 1.105 0 0 0 0 1.105v17.79A1.105 1.105 0 0 0 1.105 20h9.579v-7.719H8.07V9.239h2.6V7.018a3.637 3.637 0 0 1 3.881-3.993 21.806 21.806 0 0 1 2.344.133v2.7H15.3c-1.253 0-1.495.593-1.495 1.467v1.93h3l-.389 3.028h-2.609V20h5.088A1.105 1.105 0 0 0 20 18.895V1.105A1.105 1.105 0 0 0 18.895 0z"
				transform="translate(-777 -50)"
				fill={color}
			/>
		</g>
	</svg>
)

export const LinkedInIcon = ({ color }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<path
			id="prefix__linkedin-brands"
			d="M18.571 32H1.424A1.435 1.435 0 0 0 0 33.442v17.116A1.435 1.435 0 0 0 1.424 52h17.147A1.439 1.439 0 0 0 20 50.558V33.442A1.439 1.439 0 0 0 18.571 32zM6.045 49.143H3.08V39.6h2.969v9.545zM4.563 38.295a1.719 1.719 0 1 1 1.719-1.719 1.719 1.719 0 0 1-1.719 1.719zm12.593 10.848h-2.964V44.5c0-1.107-.022-2.531-1.54-2.531-1.545 0-1.781 1.205-1.781 2.451v4.723H7.906V39.6h2.844v1.3h.04a3.122 3.122 0 0 1 2.808-1.54c3 0 3.558 1.978 3.558 4.549z"
			transform="translate(0 -32)"
			fill={color}
		/>
	</svg>
)

export const LinkIcon = ({ color }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<path
			id="prefix__link-solid"
			d="M12.758 7.241a5.934 5.934 0 0 1 .014 8.382l-.014.014-2.625 2.625a5.937 5.937 0 0 1-8.4-8.4l1.452-1.445a.624.624 0 0 1 1.066.414 7.2 7.2 0 0 0 .379 2.059.629.629 0 0 1-.148.649l-.511.511a2.813 2.813 0 1 0 3.952 4l2.625-2.625a2.812 2.812 0 0 0 0-3.978 2.926 2.926 0 0 0-.4-.335.626.626 0 0 1-.271-.492 1.556 1.556 0 0 1 .453-1.16l.822-.822a.628.628 0 0 1 .8-.068 5.956 5.956 0 0 1 .806.671zm5.505-5.506a5.944 5.944 0 0 0-8.4 0L7.241 4.361l-.014.014a5.939 5.939 0 0 0 .816 9.054.628.628 0 0 0 .8-.068l.822-.822a1.556 1.556 0 0 0 .457-1.164.626.626 0 0 0-.271-.492 2.926 2.926 0 0 1-.4-.335 2.812 2.812 0 0 1 0-3.978l2.625-2.625a2.813 2.813 0 1 1 3.952 4l-.511.511a.629.629 0 0 0-.148.649 7.2 7.2 0 0 1 .379 2.059.624.624 0 0 0 1.066.414l1.449-1.449a5.944 5.944 0 0 0 0-8.4z"
			fill={color}
		/>
	</svg>
)

export const CheckmarkIcon = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="9.747" viewBox="0 0 12.828 9.747">
		<path
			id="prefix__icons8-checkmark"
			fill="none"
			stroke={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit="10"
			strokeWidth="2px"
			d="M15 7l-7.333 7.333L5 11.667"
			transform="translate(-3.586 -5.586)"
		/>
	</svg>
)

export const EyeOpen = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" id="prefix__ic_closed" width="22" height="16" viewBox="0 0 22 16">
		<path
			fill={color}
			id="prefix__Path_13544"
			d="M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
			data-name="Path 13544"
			transform="translate(-1 -4)"
		/>
		<path
			fill={color}
			id="prefix__Path_13545"
			d="M12 4C4 4 1 12 1 12s3 8 11 8 11-8 11-8-3-8-11-8zm0 14c-5.276 0-7.944-4.268-8.808-6C4.058 10.286 6.745 6 12 6c5.276 0 7.944 4.268 8.808 6-.865 1.714-3.553 6-8.808 6z"
			data-name="Path 13545"
			transform="translate(-1 -4)"
		/>
	</svg>
)

export const EyeClosed = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="18" viewBox="0 0 22.828 18">
		<path
			id="icon-show-password"
			fill="none"
			stroke={color}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit="10"
			strokeWidth="2px"
			d="M21.353 10.256a11.125 11.125 0 0 1-9.682 5.979A11.122 11.122 0 0 1 2 10.279m3.4-4.293a10.482 10.482 0 0 1 12.277 0m-6 10.25V20m-3.969-4.5l-1.759 3.354M4.145 13.2l-2.559 2.484m13.878-.184l1.758 3.354m1.827-5.635l2.536 2.465"
			transform="translate(-.172 -3)"
		/>
	</svg>
)

export const CloseIcon = ({ color }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" id="icon-close" width="20" height="20" viewBox="0 0 20 20">
		<path id="Area" fill="none" d="M0 0H20V20H0z" />
		<path
			id="Border"
			fill={color}
			d="M9.108 8L16 14.892 14.892 16 8 9.108 1.108 16 0 14.892 6.892 8 0 1.108 1.108 0 8 6.892 14.892 0 16 1.108z"
			transform="translate(2 2)"
		/>
	</svg>
)

export const FavoriteIcon = ({ color, outline, style = {} }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" style={style}>
		<g fill="none">
			<path
				fill={color}
				d="M13.057 20.595l5.5 3.473a1.158 1.158 0 0 0 1.707-1.3L18.8 16.223l4.858-4.4a1.211 1.211 0 0 0-.653-2.1l-6.395-.567-2.5-6.178a1.126 1.126 0 0 0-2.109 0L9.5 9.151l-6.395.567a1.211 1.211 0 0 0-.653 2.1l4.858 4.4-1.457 6.551a1.158 1.158 0 0 0 1.707 1.3z"
				transform="translate(-2.057 -2.243)"
			/>
			<path
				fill={outline}
				d="M19.145 23.243c.026 0 .07-.02.104-.063.042-.052.054-.115.037-.193l-1.46-6.546-.126-.568.43-.39 4.859-4.406c.094-.085.069-.2.054-.244-.037-.11-.102-.116-.124-.118l-6.394-.567-.61-.055-.229-.566-2.501-6.178c-.03-.073-.07-.106-.128-.106-.058 0-.098.033-.127.106l-2.502 6.178-.23.566-.608.055-6.395.567c-.021.002-.086.008-.123.118-.015.045-.04.16.054.244l4.858 4.405.43.391-.126.568-1.46 6.546c-.017.078-.005.141.037.193.035.044.079.063.104.063.015 0 .034-.007.057-.021l5.497-3.473.534-.337.534.337 5.498 3.473c.022.014.041.021.056.021m0 1c-.196 0-.398-.054-.59-.176l-5.498-3.472-5.497 3.472c-.193.122-.395.176-.59.176-.688 0-1.296-.67-1.117-1.474l1.46-6.546-4.859-4.405c-.765-.693-.356-2.01.653-2.1l6.395-.567 2.5-6.177c.198-.487.627-.73 1.055-.73.429 0 .857.243 1.055.73l2.501 6.177 6.395.568c1.009.089 1.418 1.406.652 2.1l-4.858 4.404 1.46 6.546c.179.803-.43 1.474-1.117 1.474z"
				transform="translate(-2.057 -2.243)"
			/>
		</g>
	</svg>
)

export const ArrowIcon = ({ color = '#592b86' }) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2 8.00002C2 7.80111 2.07902 7.61035 2.21967 7.46969C2.36032 7.32904 2.55109 7.25002 2.75 7.25002H11.537L8.25 4.30902C8.10307 4.17606 8.01474 3.99036 8.00429 3.79247C7.99384 3.59459 8.06213 3.40062 8.19424 3.25292C8.32635 3.10523 8.51154 3.01581 8.70935 3.00422C8.90717 2.99262 9.10154 3.05978 9.25 3.19102L14 7.44102C14.0786 7.51137 14.1416 7.59752 14.1846 7.69385C14.2277 7.79018 14.25 7.89451 14.25 8.00002C14.25 8.10554 14.2277 8.20987 14.1846 8.3062C14.1416 8.40252 14.0786 8.48868 14 8.55902L9.25 12.809C9.1767 12.8754 9.09101 12.9265 8.99786 12.9596C8.90471 12.9927 8.80593 13.0071 8.70721 13.0019C8.60849 12.9967 8.51177 12.972 8.42262 12.9293C8.33347 12.8865 8.25365 12.8266 8.18774 12.7529C8.12183 12.6793 8.07115 12.5933 8.03859 12.4999C8.00603 12.4066 7.99225 12.3077 7.99804 12.209C8.00382 12.1103 8.02906 12.0138 8.0723 11.9249C8.11555 11.836 8.17593 11.7565 8.25 11.691L11.537 8.75002H2.75C2.55109 8.75002 2.36032 8.67101 2.21967 8.53035C2.07902 8.3897 2 8.19894 2 8.00002Z"
			fill={color}
		/>
	</svg>
)

export const TwitterIcon = ({ color }: Props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="29" height="24" viewBox="0 0 29 24">
		<g id="prefix__icons_ic_twitter" data-name="icons / ic_twitter" transform="translate(-75.1 -98.4)">
			<path
				id="prefix__Path_339"
				d="M84.21 122.4c10.943 0 16.931-9.236 16.931-17.232 0-.26 0-.52-.012-.78a12.245 12.245 0 0 0 2.971-3.142 11.9 11.9 0 0 1-3.423.957 6.075 6.075 0 0 0 2.623-3.354 11.712 11.712 0 0 1-3.783 1.465 5.892 5.892 0 0 0-4.34-1.913 6.012 6.012 0 0 0-5.953 6.059 6.809 6.809 0 0 0 .151 1.382 16.8 16.8 0 0 1-12.267-6.332 6.153 6.153 0 0 0 1.845 8.091 5.939 5.939 0 0 1-2.692-.756v.083a6.044 6.044 0 0 0 4.77 5.941 5.884 5.884 0 0 1-2.681.106 5.965 5.965 0 0 0 5.559 4.2 11.8 11.8 0 0 1-7.392 2.6 11.254 11.254 0 0 1-1.417-.075 16.712 16.712 0 0 0 9.11 2.7"
				data-name="Path 339"
				style={{ fill: color }}
			/>
		</g>
	</svg>
)
export { MoneyBag } from 'components/patterns/icons/productIcons'
